import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, url, canonical, type = 'website', children }) {
  const siteUrl = 'https://chapter24.co.in';
  const rawPath = url || canonical || '';
  const cleanPath = rawPath ? (rawPath.startsWith('/') ? rawPath : `/${rawPath}`) : '';
  const fullUrl = cleanPath ? `${siteUrl}${cleanPath}` : `${siteUrl}/`;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {children}
    </Helmet>
  );
}
